/* ============================================================
   WOODEN DECOR THEME — theme.js
   ============================================================ */

(function () {
  'use strict';

  /* ── Sticky Header + Transparent-to-Solid ─────────────────── */
  var header = document.getElementById('site-header');

  function updateHeaderOnScroll() {
    if (!header) return;
    if (window.scrollY > 60) {
      header.classList.add('site-header--scrolled');
    } else {
      header.classList.remove('site-header--scrolled');
    }
  }

  if (header) {
    window.addEventListener('scroll', updateHeaderOnScroll, { passive: true });
    updateHeaderOnScroll();
  }

  /* ── Mobile Navigation ─────────────────────────────────────── */
  var mobileToggle = document.querySelector('[data-action="toggle-mobile-nav"]');
  var mobileNav = document.getElementById('mobile-nav');

  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      var isOpen = mobileNav.classList.toggle('is-open');
      mobileToggle.setAttribute('aria-expanded', String(isOpen));
      mobileNav.setAttribute('aria-hidden', String(!isOpen));
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) {
        mobileNav.classList.remove('is-open');
        mobileToggle.setAttribute('aria-expanded', 'false');
        mobileNav.setAttribute('aria-hidden', 'true');
        mobileToggle.focus();
      }
    });

    document.addEventListener('click', function (e) {
      if (header && !header.contains(e.target) && mobileNav.classList.contains('is-open')) {
        mobileNav.classList.remove('is-open');
        mobileToggle.setAttribute('aria-expanded', 'false');
        mobileNav.setAttribute('aria-hidden', 'true');
      }
    });
  }

  /* ── Search Overlay ───────────────────────────────────────── */
  var searchOverlay = document.getElementById('search-overlay');
  var searchInput = document.getElementById('search-input');

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { if (searchInput) searchInput.focus(); }, 50);
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-action="open-search"]').forEach(function (btn) {
    btn.addEventListener('click', openSearch);
  });

  document.querySelectorAll('[data-action="close-search"]').forEach(function (el) {
    el.addEventListener('click', closeSearch);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchOverlay && !searchOverlay.hasAttribute('hidden')) {
      closeSearch();
    }
  });

  /* ── Section Fade-In on Scroll ─────────────────────────────── */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var style = document.createElement('style');
    style.textContent = '.animate-in { opacity: 1 !important; transform: translateY(0) !important; }';
    document.head.appendChild(style);

    var animSections = document.querySelectorAll(
      '.trust-pillars-section, .featured-products-section, .brand-story-section, .testimonials-section, .email-cta-section, .pdp-tabs, .pdp-related, .b2b-page section'
    );

    var sectionObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
          sectionObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });

    animSections.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.55s ease, transform 0.55s ease';
      sectionObs.observe(el);
    });
  }

  /* ── PDP Gallery Thumbnails ────────────────────────────────── */
  var thumbs = document.querySelectorAll('.pdp-gallery__thumb');
  var mainImg = document.getElementById('pdp-main-img');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!mainImg) return;
      var src = thumb.dataset.src;
      var srcset = thumb.dataset.srcset;
      mainImg.src = src;
      if (srcset) mainImg.srcset = srcset;
      thumbs.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-pressed', 'false');
      });
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-pressed', 'true');
    });
  });

  /* ── PDP Accordion Tabs ────────────────────────────────────── */
  var tabTriggers = document.querySelectorAll('.pdp-tab__trigger');

  tabTriggers.forEach(function (trigger) {
    var bodyId = trigger.getAttribute('aria-controls');
    var body = document.getElementById(bodyId);
    if (!body) return;

    // Init: handle pre-opened tab from server
    if (trigger.getAttribute('aria-expanded') === 'true') {
      body.removeAttribute('hidden');
    }

    trigger.addEventListener('click', function () {
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!expanded));
      if (expanded) {
        body.setAttribute('hidden', '');
      } else {
        body.removeAttribute('hidden');
      }
    });
  });

  /* ── PDP Variant Swatches ──────────────────────────────────── */
  var swatchInputs = document.querySelectorAll('.pdp-swatch__input');

  swatchInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      // Update selected label display
      var optionIndex = input.dataset.optionIndex;
      var valDisplay = document.getElementById('pdp-option-val-' + (parseInt(optionIndex) + 1));
      if (valDisplay) valDisplay.textContent = input.value;

      // Update swatch active state
      var group = input.closest('.pdp-option__swatches');
      if (group) {
        group.querySelectorAll('.pdp-swatch').forEach(function (s) { s.classList.remove('is-selected'); });
        input.closest('.pdp-swatch').classList.add('is-selected');
      }

      // Find matching variant and update price + hidden id
      var form = document.getElementById('pdp-form');
      if (!form) return;

      var allSelected = Array.from(form.querySelectorAll('.pdp-swatch__input:checked')).map(function (i) { return i.value; });
      var variantId = form.querySelector('[name="id"]');
      if (!variantId) return;

      // Shopify variant lookup via product JSON
      fetch(window.location.pathname + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) {
          var match = product.variants.find(function (v) {
            return v.options.every(function (opt, idx) { return opt === allSelected[idx]; });
          });
          if (!match) return;

          variantId.value = match.id;

          var priceEl = document.getElementById('pdp-price');
          var compareEl = document.getElementById('pdp-compare-price');
          if (priceEl) priceEl.textContent = formatMoney(match.price);
          if (compareEl && match.compare_at_price) {
            compareEl.textContent = formatMoney(match.compare_at_price);
            compareEl.style.display = match.compare_at_price > match.price ? '' : 'none';
          }

          var buyNow = document.getElementById('pdp-buy-now');
          if (buyNow) {
            buyNow.href = '/cart/' + match.id + ':1?checkout';
          }

          var atcBtn = document.querySelector('.pdp-cta__atc');
          if (atcBtn) {
            if (match.available) {
              atcBtn.disabled = false;
              atcBtn.textContent = 'Add to Cart';
            } else {
              atcBtn.disabled = true;
              atcBtn.textContent = 'Sold Out';
            }
          }
        })
        .catch(function () {});
    });
  });

  function formatMoney(amount) {
    return '$' + (amount / 100).toFixed(2);
  }

  /* ── PDP Quantity Stepper ──────────────────────────────────── */
  var qtyInput = document.querySelector('.pdp-qty__input');
  document.querySelectorAll('.pdp-qty__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!qtyInput) return;
      var val = parseInt(qtyInput.value) || 1;
      if (btn.dataset.action === 'increment') {
        qtyInput.value = val + 1;
      } else if (btn.dataset.action === 'decrement' && val > 1) {
        qtyInput.value = val - 1;
      }
    });
  });

  /* ── PDP Engrave Character Counter ─────────────────────────── */
  var engraveInput = document.getElementById('engrave-text');
  var engraveCount = document.getElementById('engrave-count');
  if (engraveInput && engraveCount) {
    engraveInput.addEventListener('input', function () {
      engraveCount.textContent = engraveInput.value.length;
    });
  }

  /* ── Cart Count Live Update ────────────────────────────────── */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var countEl = document.querySelector('.header__cart-count');
        if (cart.item_count > 0) {
          if (!countEl) {
            var btn = document.querySelector('.header__cart-btn');
            if (btn) {
              var span = document.createElement('span');
              span.className = 'header__cart-count';
              span.setAttribute('aria-hidden', 'true');
              span.textContent = cart.item_count;
              btn.appendChild(span);
            }
          } else {
            countEl.textContent = cart.item_count;
          }
        } else if (countEl) {
          countEl.remove();
        }
      })
      .catch(function () {});
  }

  document.addEventListener('cart:updated', updateCartCount);

  /* ── Cart Drawer ────────────────────────────────────────────── */
  function openCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function refreshCartDrawer() {
    return fetch('/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newDrawer = doc.getElementById('cart-drawer');
        var oldDrawer = document.getElementById('cart-drawer');
        if (newDrawer && oldDrawer) {
          if (oldDrawer.classList.contains('is-open')) {
            newDrawer.classList.add('is-open');
            newDrawer.setAttribute('aria-hidden', 'false');
          }
          oldDrawer.replaceWith(newDrawer);
          bindCartDrawerEvents();
        }
      })
      .catch(function () {});
  }

  function cartChange(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        updateCartCount();
        document.dispatchEvent(new CustomEvent('cart:updated'));
        return refreshCartDrawer();
      });
  }

  function bindCartDrawerEvents() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    drawer.querySelectorAll('[data-action="close-cart-drawer"]').forEach(function (el) {
      el.addEventListener('click', closeCartDrawer);
    });

    drawer.querySelectorAll('[data-action="qty-decrease"], [data-action="qty-increase"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        var qty = parseInt(btn.getAttribute('data-qty'), 10);
        if (isNaN(qty) || qty < 0) qty = 0;
        cartChange(key, qty);
      });
    });

    var upsellBtn = drawer.querySelector('[data-action="add-upsell"]');
    if (upsellBtn) {
      upsellBtn.addEventListener('click', function () {
        var variantId = upsellBtn.getAttribute('data-variant-id');
        upsellBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            updateCartCount();
            document.dispatchEvent(new CustomEvent('cart:updated'));
            return refreshCartDrawer();
          })
          .catch(function () {})
          .then(function () { upsellBtn.disabled = false; });
      });
    }
  }

  document.querySelectorAll('[data-action="open-cart-drawer"]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openCartDrawer();
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var drawer = document.getElementById('cart-drawer');
      if (drawer && drawer.classList.contains('is-open')) closeCartDrawer();
    }
  });

  bindCartDrawerEvents();

  /* ── PDP Add to Cart (AJAX → Cart Drawer) ──────────────────── */
  var pdpForm = document.getElementById('pdp-form');
  if (pdpForm) {
    pdpForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = pdpForm.querySelector('[name="add"]');
      if (!submitBtn || submitBtn.disabled) return;
      var originalText = submitBtn.textContent;
      submitBtn.textContent = 'Adding...';
      submitBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(Object.fromEntries(new FormData(pdpForm)))
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok) {
            submitBtn.textContent = result.data.description || 'Something went wrong';
            setTimeout(function () {
              submitBtn.textContent = originalText;
              submitBtn.disabled = false;
            }, 2000);
            return;
          }
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
          updateCartCount();
          document.dispatchEvent(new CustomEvent('cart:updated'));
          refreshCartDrawer().then(openCartDrawer);
        })
        .catch(function () {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        });
    });
  }

  /* ── Sticky Add to Cart bar (PDP) ──────────────────────────── */
  var stickyAtc = document.getElementById('sticky-atc');
  var ctaGroup = document.querySelector('.pdp-cta-group');
  if (stickyAtc && ctaGroup) {
    var ctaObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyAtc.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    ctaObserver.observe(ctaGroup);

    var siteFooter = document.querySelector('.site-footer');
    if (siteFooter) {
      var footerObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            stickyAtc.classList.remove('is-visible');
          }
        });
      }, { threshold: 0 });
      footerObserver.observe(siteFooter);
    }

    var stickyBtn = document.getElementById('sticky-atc-btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var atcBtn = document.querySelector('.pdp-cta__atc');
        if (atcBtn) {
          atcBtn.click();
          ctaGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }

    var pdpPriceEl = document.getElementById('pdp-price');
    var stickyPriceEl = document.getElementById('sticky-atc-price');
    if (pdpPriceEl && stickyPriceEl) {
      stickyPriceEl.textContent = pdpPriceEl.textContent;
      var priceObserver = new MutationObserver(function () {
        stickyPriceEl.textContent = pdpPriceEl.textContent;
      });
      priceObserver.observe(pdpPriceEl, { childList: true, characterData: true, subtree: true });
    }
  }

  /* ── Related Products (PDP) ────────────────────────────────── */
  var relatedSection = document.querySelector('.related-products[data-product-id]');
  if (relatedSection) {
    var relatedUrl = relatedSection.getAttribute('data-url');
    var relatedInner = relatedSection.querySelector('.related-products__inner');
    if (relatedUrl && relatedInner) {
      fetch(relatedUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newInner = doc.querySelector('.related-products__inner');
          if (newInner && newInner.children.length) {
            relatedInner.innerHTML = newInner.innerHTML;
            relatedInner.classList.remove('related-products__inner--hidden');
            relatedSection.classList.add('is-loaded');
          }
        })
        .catch(function () {});
    }
  }

  /* ── Announcement Bar: rotation + dismiss ──────────────────── */
  var annBar = document.getElementById('announcement-bar');
  if (annBar) {
    var annDismissed = false;
    try { annDismissed = sessionStorage.getItem('announcement-dismissed') === '1'; } catch (e) {}
    if (annDismissed) {
      annBar.remove();
    } else {
      var annSlot = document.getElementById('announcement-bar-slot');
      var annTemplates = annBar.querySelectorAll('.announcement-bar__data template');
      if (annSlot && annTemplates.length > 1) {
        var annMessages = [];
        annTemplates.forEach(function (tpl) {
          annMessages.push({ text: tpl.getAttribute('data-text') || '', url: tpl.getAttribute('data-url') || '' });
        });
        var annIndex = 0;
        var annInterval = (parseInt(annBar.getAttribute('data-rotate-interval'), 10) || 5) * 1000;
        setInterval(function () {
          annIndex = (annIndex + 1) % annMessages.length;
          var msg = annMessages[annIndex];
          annSlot.classList.add('is-fading');
          setTimeout(function () {
            if (msg.url) {
              annSlot.innerHTML = '<a href="' + msg.url + '" class="announcement-bar__link" style="color:inherit;">' + msg.text + '</a>';
            } else {
              annSlot.innerHTML = '<p class="announcement-bar__text">' + msg.text + '</p>';
            }
            annSlot.classList.remove('is-fading');
          }, 250);
        }, annInterval);
      }

      var annClose = annBar.querySelector('[data-action="dismiss-announcement"]');
      if (annClose) {
        annClose.addEventListener('click', function () {
          annBar.remove();
          try { sessionStorage.setItem('announcement-dismissed', '1'); } catch (e) {}
        });
      }
    }
  }

  /* ── Recently Viewed Products ──────────────────────────────── */
  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function buildProductCardHTML(p) {
    var price = formatMoney(p.price);
    var compareHTML = '';
    if (p.compare_at_price && p.compare_at_price > p.price) {
      compareHTML = '<span class="product-card__compare-price"><s>' + formatMoney(p.compare_at_price) + '</s></span>';
    }
    var img = p.featured_image
      ? '<img src="' + p.featured_image + '" alt="' + escapeHtml(p.title) + '" class="product-card__image" loading="lazy" width="600" height="600">'
      : '';
    return '' +
      '<article class="product-card" aria-label="' + escapeHtml(p.title) + '">' +
        '<a href="' + p.url + '" class="product-card__image-link" tabindex="-1" aria-hidden="true">' +
          '<div class="product-card__image-wrap">' + img + '<span class="product-card__badge product-card__badge--teak">100% Teak Wood</span></div>' +
        '</a>' +
        '<div class="product-card__info">' +
          (p.type ? '<p class="product-card__type">' + escapeHtml(p.type) + '</p>' : '') +
          '<h3 class="product-card__title"><a href="' + p.url + '" class="product-card__title-link">' + escapeHtml(p.title) + '</a></h3>' +
          '<div class="product-card__price-row"><span class="product-card__price">' + price + '</span>' + compareHTML + '</div>' +
          '<a href="' + p.url + '" class="product-card__cta">View Details' +
            '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M3 7h8M7 3l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</a>' +
        '</div>' +
      '</article>';
  }

  var rvSection = document.querySelector('[data-recently-viewed]');
  if (rvSection) {
    var rvStorageKey = 'wd_recently_viewed';
    var rvCurrentHandle = rvSection.getAttribute('data-current-handle');
    var rvLimit = parseInt(rvSection.getAttribute('data-limit'), 10) || 4;
    var rvViewed = [];
    try { rvViewed = JSON.parse(localStorage.getItem(rvStorageKey)) || []; } catch (e) {}

    var rvToShow = rvViewed.filter(function (h) { return h && h !== rvCurrentHandle; }).slice(0, rvLimit);

    if (rvToShow.length) {
      var rvGrid = document.getElementById('recently-viewed-grid');
      Promise.all(rvToShow.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })).then(function (products) {
        products.filter(Boolean).forEach(function (p) {
          rvGrid.insertAdjacentHTML('beforeend', buildProductCardHTML(p));
        });
        if (rvGrid.children.length) {
          rvSection.removeAttribute('hidden');
        }
      });
    }

    if (rvCurrentHandle) {
      rvViewed = rvViewed.filter(function (h) { return h !== rvCurrentHandle; });
      rvViewed.unshift(rvCurrentHandle);
      rvViewed = rvViewed.slice(0, 12);
      try { localStorage.setItem(rvStorageKey, JSON.stringify(rvViewed)); } catch (e) {}
    }
  }

  /* ── Shoppable Photo (hotspot ↔ product list) ──────────────── */
  document.querySelectorAll('.shoppable-photo').forEach(function (section) {
    var hotspots = section.querySelectorAll('.shoppable-photo__hotspot');
    var cards = section.querySelectorAll('.shoppable-photo__product-card');

    function setActive(index) {
      hotspots.forEach(function (h) {
        h.classList.toggle('is-active', h.getAttribute('data-hotspot-index') === index);
      });
      cards.forEach(function (c) {
        c.classList.toggle('is-active', c.getAttribute('data-hotspot-index') === index);
      });
    }

    hotspots.forEach(function (hotspot) {
      hotspot.addEventListener('click', function () {
        var index = hotspot.getAttribute('data-hotspot-index');
        var wasActive = hotspot.classList.contains('is-active');
        setActive(wasActive ? null : index);
        if (!wasActive) {
          var card = section.querySelector('.shoppable-photo__product-card[data-hotspot-index="' + index + '"]');
          if (card) card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    });

    cards.forEach(function (card) {
      card.addEventListener('mouseenter', function () {
        setActive(card.getAttribute('data-hotspot-index'));
      });
    });
  });

  /* ── Craftsmanship Video (click-to-play embed) ─────────────── */
  document.querySelectorAll('.craft-video__play').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var src = btn.getAttribute('data-video-src');
      if (!src) return;
      var iframe = document.createElement('iframe');
      iframe.className = 'craft-video__embed';
      iframe.src = src;
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.title = 'Video';
      btn.replaceWith(iframe);
    });
  });

  /* ── Product Finder Quiz ────────────────────────────────────── */
  document.querySelectorAll('[data-product-finder]').forEach(function (finder) {
    var stepsWrap = finder.querySelector('.finder__steps');
    var steps = finder.querySelectorAll('.finder__step');
    var resultsWrap = finder.querySelector('.finder__results');
    var results = finder.querySelectorAll('.finder__result');
    var progressEl = finder.querySelector('.finder__progress');
    var progressFill = finder.querySelector('.finder__progress-fill');
    var totalSteps = steps.length;
    var scores = {};

    function showStep(index) {
      steps.forEach(function (step, i) {
        step.hidden = i !== index;
      });
      if (progressFill) progressFill.style.width = (index / totalSteps * 100) + '%';
    }

    function showResult() {
      var bestKey = null, bestScore = -1;
      Object.keys(scores).forEach(function (key) {
        if (scores[key] > bestScore) { bestScore = scores[key]; bestKey = key; }
      });
      if (progressFill) progressFill.style.width = '100%';
      if (progressEl) progressEl.hidden = true;
      stepsWrap.hidden = true;
      resultsWrap.hidden = false;
      var matched = false;
      results.forEach(function (r) {
        var isMatch = r.getAttribute('data-key') === bestKey;
        r.hidden = !isMatch;
        if (isMatch) matched = true;
      });
      if (!matched && results.length) results[0].hidden = false;
    }

    function reset() {
      scores = {};
      results.forEach(function (r) { r.hidden = true; });
      resultsWrap.hidden = true;
      if (progressEl) progressEl.hidden = false;
      stepsWrap.hidden = false;
      showStep(0);
    }

    finder.querySelectorAll('.finder__option').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.closest('.finder__step');
        var stepIndex = parseInt(step.getAttribute('data-step'), 10);
        var value = btn.getAttribute('data-value');
        if (value) scores[value] = (scores[value] || 0) + 1;
        if (stepIndex + 1 < totalSteps) {
          showStep(stepIndex + 1);
        } else {
          showResult();
        }
      });
    });

    finder.querySelectorAll('.finder__retry').forEach(function (btn) {
      btn.addEventListener('click', reset);
    });

    if (totalSteps > 0) showStep(0);
  });

  /* ── Quick Add to Cart (shoppable photo, etc.) ─────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action="quick-add"]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    btn.disabled = true;
    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        updateCartCount();
        document.dispatchEvent(new CustomEvent('cart:updated'));
        return refreshCartDrawer().then(openCartDrawer);
      })
      .catch(function () {})
      .then(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  });

  /* ── Back to Top Button ───────────────────────────────────── */
  var backToTop = document.getElementById('back-to-top');
  if (backToTop) {
    var stickyAtcBar = document.getElementById('sticky-atc');

    function updateBackToTop() {
      backToTop.classList.toggle('is-visible', window.scrollY > 600);
      backToTop.classList.toggle('is-above-bar', !!(stickyAtcBar && stickyAtcBar.classList.contains('is-visible')));
    }

    window.addEventListener('scroll', updateBackToTop, { passive: true });
    updateBackToTop();

    backToTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

})();
